export class GalleryItem {
  _id?: string;
  image: string = '';
  video: string = '';
  thumbnail: string = '';
  backgroundImage: string = '';
  backgroundColor: string = '';
  alt: string = '';
  position: number = 0;
  showInList: boolean = false;
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/models/gallery-item.model.ts